// extracted by mini-css-extract-plugin
export default {"card":"RootPageCard_card__gP4ev","subHeading":"RootPageCard_subHeading__5rxgA","subText":"RootPageCard_subText__3UCxK","fields":"RootPageCard_fields__pwUiD"};